<template>
  <section class="change-email-stepper-wrapper__form ion-padding">
    <Form
      form-name="changeEmail"
      id="changeEmailForm"
      :validation-schema="schemaSelected"
      @submit="handleChangeEmailSubmit"
    >
      <ion-row>
        <ion-col size="12">
          <swiper ref="changePasswordSwiper" :modules="[Navigation]" @swiper="onSwiper">
            <swiper-slide class="swiper-no-swiping">
              <ion-row>
                <ion-col size="12">
                  <h4 class="h4 mt-8">{{ t('actions.changeEmail') }}</h4>
                  <p class="mt-8 text-xs">{{ t('profile.email.description') }}</p>
                  <div class="mt-32">
                    <CustomInput
                      form-name="change-password"
                      type="text"
                      :value="emailInput"
                      v-model="emailInput"
                      input-type="email"
                      :label="t('profile.email.emailPlaceholder')"
                      name="email"
                      class-name="custom-field"
                      placeholder="name@domain.com"
                      :icon="mailOutline"
                    />
                  </div>
                </ion-col>
              </ion-row>
            </swiper-slide>
            <swiper-slide class="swiper-no-swiping">
              <ion-row>
                <ion-col size="12">
                  <h4 class="h4 mt-8">{{ t('actions.changeEmail') }}</h4>
                  <p class="mt-8 text-xs">{{ t('profile.email.description') }}</p>
                  <div class="mt-32">
                    <CustomInput
                      form-name="change-password"
                      type="text"
                      :value="codeInput"
                      v-model="codeInput"
                      input-type="number"
                      :label="t('profile.email.codePlaceholder')"
                      name="code"
                      class-name="custom-field"
                      :placeholder="t('profile.email.codePlaceholder')"
                    />
                  </div>
                </ion-col>
              </ion-row>
            </swiper-slide>
          </swiper>
        </ion-col>
      </ion-row>
      <ion-row v-if="swiperChangeEmail?.activeIndex == 0">
        <ion-col size="6">
          <ion-button
            expand="block"
            color="primary"
            fill="clear"
            class="text-weight-bold"
            @click="$emit('close')"
            >{{ t('actions.discard') }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            expand="block"
            color="primary"
            fill="solid"
            class="text-weight-bold"
            type="submit"
            >{{ t('actions.saveEmail') }}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="6">
          <ion-button
            expand="block"
            color="primary"
            fill="clear"
            class="text-weight-bold"
            @click="resendCode"
            >{{ t('actions.resendCode') }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            expand="block"
            color="primary"
            fill="solid"
            class="text-weight-bold"
            type="submit"
            >{{ t('actions.confirm') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </Form>
  </section>
</template>
<script setup lang="ts">
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Navigation } from 'swiper/modules';
  import { mailOutline } from 'ionicons/icons';
  import { IonButton, IonCol, IonRow } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { Form } from 'vee-validate';
  import { useProfile } from '@/composables/useProfile';
  import { computed, ref } from 'vue';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { useAuth } from '@/composables/useAuth';
  import { useSchemas } from '@/composables/useSchemas';

  const { t } = useI18n();
  const {
    swiperChangeEmail,
    toggleChangeEmail,
    changeEmailSuccess,
    handleChangeEmail,
    handleVerifyCode,
  } = useProfile();

  const { user } = useAuth();
  const { schemaChangeEmail, schemaChangeEmailCode } = useSchemas();

  const emailInput = ref(user.value?.email || '');
  const codeInput = ref('');

  const schemaSelected = computed(() => {
    switch (swiperChangeEmail.value?.activeIndex) {
      case 0:
        return schemaChangeEmail;
      case 1:
        return schemaChangeEmailCode;
      default:
        return schemaChangeEmail;
    }
  });

  function onSwiper(swiper: any) {
    swiperChangeEmail.value = swiper;
  }

  const handleChangeEmailSubmit = () => {
    switch (swiperChangeEmail.value?.activeIndex) {
      case 0:
        handleChangeEmail(emailInput.value).then(() => {
          if (changeEmailSuccess.value) {
            swiperChangeEmail.value?.slideNext();
          }
        });
        break;
      case 1:
        handleVerifyCode(emailInput.value, codeInput.value).then(() => {
          if (changeEmailSuccess.value) {
            toggleChangeEmail.value = false;
            emailInput.value = '';
            codeInput.value = '';
          }
        });
        break;
      default:
        handleChangeEmail(emailInput.value).then(() => {
          swiperChangeEmail.value?.slideNext();
        });
        break;
    }
  };

  const resendCode = () => {
    handleChangeEmail(emailInput.value);
  };
</script>
<style scoped lang="scss">
  .change-email-stepper-wrapper {
    &__form {
      width: 100%;
      border-radius: 16px;
      background: #ffffff;
    }
  }

  .swiper {
    overflow: visible !important;
  }

  .swiper-slide-prev,
  .swiper-slide-next {
    visibility: hidden;
  }

  .dp__outer_menu_wrap,
  .dp--menu-wrapper {
    overflow: hidden;
    background: #1c4197;
  }
</style>
